import styled from 'styled-components';
import { media } from 'helpers/breakpoints';
import { ShareIosOutlineIc } from '@dsch/dd-icons';

import { GhostButton } from '../../../components/Toolkit/Button/GhostButton';
export interface ShareAdProps {
  handleShareAd: (t: boolean) => void;
  className?: string;
  iconSizeDesktop?: 'SM' | 'MD';
}

const Action = styled(GhostButton)`
  span {
    display: none;
    color: ${({ theme }) => theme.colors.GREY_DARKER};
  }

  ${media.medium} {
    span {
      display: inline;
    }
  }
`;

const Text = styled.span`
  ${({ theme }) => theme.fontSize.M16}
  font-weight: ${({ theme }) => theme.fontWeight.bold};

  ${media.smallOnly} {
    ${({ theme }) => theme.fontSize.B14}
  }
`;

const SShareIosOutlineIc = styled(ShareIosOutlineIc)<{
  $iconDimensionDesktop: number;
}>`
  color: ${({ theme }) => theme.colors.GREY_DARKER};

  ${media.medium} {
    width: ${({ $iconDimensionDesktop }) => `${$iconDimensionDesktop}px`};
    height: ${({ $iconDimensionDesktop }) => `${$iconDimensionDesktop}px`};
  }
`;

function shareAd(handleShareAd: (t: boolean) => void) {
  handleShareAd(true);
}

function ShareAd({ className, handleShareAd, iconSizeDesktop }: ShareAdProps) {
  const iconDimensionDesktop = iconSizeDesktop === 'SM' ? 20 : 24;
  return (
    <Action
      className={className}
      size="SMALL"
      onClick={() => shareAd(handleShareAd)}
      data-testid="share-cad"
    >
      <SShareIosOutlineIc $iconDimensionDesktop={iconDimensionDesktop} />
      <Text>Share</Text>
    </Action>
  );
}

export { ShareAd };
